/* global currentUrl */
import startsWith from 'lodash/startsWith';

// currentUrl can be received from build script
// fallback to polyfill for IE

currentUrl = currentUrl || window.document.currentScript?.getAttribute('src') || undefined;

// dev localhost env fix
if (startsWith(currentUrl, '/') && !startsWith(currentUrl, '//')) {
  currentUrl = `${window.location.origin}${currentUrl}`;
}

// we'd need the domain name to set paths for all API call's
// needs to be launched at index.ts
export const getCurrentScriptURL = (() => {
  // toyota prod url, we don't want to prod url be visible in the source as plain text.
  const fallbackUrl =
    '\u0068\u0074\u0074\u0070\u0073\u003A\u002F\u002F\u0074\u006F\u0079\u006F\u0074\u0061\u002E\u0069\u006E\u0073\u0075\u0072\u0061\u006E\u0063\u0065\u002E\u006D\u0061\u006B\u006F\u006C\u0061\u0062\u002E\u0063\u006F\u006D';

  if (!currentUrl) {
    console.error(new Error(`Can't resolve hostname, ${fallbackUrl} will be used to load assets.`));
  }

  return (): string => {
    return new URL(currentUrl || fallbackUrl).origin;
  };
})();

// Warning! Do not touch unless you know what you are doing!
// See https://jira.makolab.net/browse/JICP-433
// See https://webpack.js.org/guides/public-path/#on-the-fly
if (process.env.NODE_ENV === 'production') {
  __webpack_public_path__ = `${getCurrentScriptURL()}/`;
}
